module.exports = __webpack_public_path__ + "img/question16c1.de45f1f4.png";